import { combineReducers, StateFromReducersMapObject } from 'redux';

import { apiSlice } from '../../api/apiSlice.js';
import { currenciesApi } from '../../api/currenciesApi.js';
import { insertionOrderApi } from '../../api/insertionOrderApi.js';
import recommendations from './recommedations.js';
import recommendationsSettings from './recommedationsSettings.js';
import recoSettingsPrioritisationGoal from './recoSettingsPriorityChange.js';

export const reducers = {
  recommendations,
  recommendationsSettings,
  recoSettingsPrioritisationGoal,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [insertionOrderApi.reducerPath]: insertionOrderApi.reducer,
  [currenciesApi.reducerPath]: currenciesApi.reducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = StateFromReducersMapObject<typeof reducers>;

export default rootReducer;
